export const breakpoints = {
  xs: '480px',
  sm: '1024px',
  md: '1024px',
  lg: '1200px',
  xl: '1536px',
};

export const palette = {
  primary: {
    main: '#6f9fe9',
    secondary: 'rgba(111, 159, 233, .2)',
  },
  secondary: {
    main: '#6f9fe9',
  },
  success: {
    main: '#004C56',
    100: '#DCFCE7',
    200: '#BBF7D0',
    300: '#6EE7B7',
    150: '#A1EED0',
    500: '#22C55E',
    600: '#16A34A',
    700: '#15803D',
    800: '#166534',
  },
  error: {
    main: '#FC3636',
    50: '#FEF2F2',
    200: '#FECACA',
    300: '#F6BFBF',
    400: '#EF4444',
    450: '#EF4444',
    500: '#EF4444',
    600: '#D97706',
    700: '#B45309',
  },
  warning: {
    main: '#F19D41', // TODO: check if this is correct
    200: '#FDE68A',
    400: '#FBBF24',
    500: '#F59E0B', // TODO: check if this is correct
    600: '#D97706',
    700: '#B45309',
  },
  text: {
    primary: '#2B2B2B',
    secondary: '#485651',
  },
  breakpoints: {
    values: breakpoints,
  },
};
